import React from 'react';
import SelectFromEnum from '../SelectFromEnum';
import { SelectProps } from '../Select';
import { VehicleMakeEnum } from '../../models/gen/graphql';

const SelectVehicleMake = (props: SelectProps): React.JSX.Element => <SelectFromEnum source={VehicleMakeEnum} {...props} />;

export default SelectVehicleMake;
